import { connect } from 'react-redux';

import VariantPrice from '../components/VariantPrice';
import { variantWithSku } from 'common/selectors';
import { gon } from 'common/gon';

const mapStateToProps = (state, props) => {
  const variant = variantWithSku(props.variantSku, state);

  return {
    isMembershipOrder: state.currentOrder.membership_order,
    membershipDiscountRate: state.membershipDiscountRate,
    baseAmount: variant === null ? 0.0 : parseFloat(variant.price),
    isSubscribable: variant === null ? false : variant.is_subscribable,
    subscribableVariantDiscountRate: state.subscribableVariantDiscountRate,
    showStrikethroughPrices:
      typeof gon('current_store.preferences.show_strikethrough_prices') !==
        'undefined' &&
      gon('current_store.preferences.show_strikethrough_prices'),
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VariantPrice);
